import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: 'app-two-form-factor',
  templateUrl: './two-factor-form.component.html',
  styleUrls: ['./two-factor-form.component.scss'],
})
export class TwoFactorFormComponent {
  @Output()
  submitForm = new EventEmitter<string>();

  @Output() resetToSignin = new EventEmitter<void>();

  @Input()
  spinner: boolean = false;

  protected twofacode: string = '';
  private questions = {};
  
  constructor(
    private router: Router,
  ) {}

  protected questionOpen(name) {
    return this.questions[name];
  }

  protected get isFormValid() {
    return this.twofacode;
  }

  // UI handlers
  protected onSubmit = () => {
    this.submitForm.emit(this.twofacode);
  }

  protected toggleQuestion(name) {
    this.questions[name] = !this.questions[name];
  }


  protected onClickLogin() {
    localStorage.removeItem('sync_auth');
    this.resetToSignin.emit();
  }
}
